import { render } from "./DefaultNotification.vue?vue&type=template&id=a8b906ee&scoped=true&ts=true"
import script from "./DefaultNotification.vue?vue&type=script&lang=ts"
export * from "./DefaultNotification.vue?vue&type=script&lang=ts"

import "./DefaultNotification.vue?vue&type=style&index=0&id=a8b906ee&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8b906ee"]])

export default __exports__